import { render, staticRenderFns } from "./IconCheck.vue?vue&type=template&id=4c24df4c&scoped=true&"
import script from "./IconCheck.vue?vue&type=script&lang=js&"
export * from "./IconCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c24df4c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c24df4c')) {
      api.createRecord('4c24df4c', component.options)
    } else {
      api.reload('4c24df4c', component.options)
    }
    module.hot.accept("./IconCheck.vue?vue&type=template&id=4c24df4c&scoped=true&", function () {
      api.rerender('4c24df4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/IconCheck.vue"
export default component.exports